const ServicesSection = () => {
  const services = [
    {
      title: 'Vaciado de Pisos y Casas',
      description: 'Vaciado completo de viviendas con retirada de muebles, enseres y limpieza final. Servicio rápido y profesional.',
      icon: 'ri-home-4-line',
      image: 'https://public.readdy.ai/ai/img_res/0d27111ffc136668b188a54f6e2e8c31.jpg',
    },
    {
      title: 'Vaciado de Locales Comerciales',
      description: 'Vaciado de oficinas, tiendas y locales comerciales. Gestión integral de residuos y limpieza profesional.',
      icon: 'ri-store-2-line',
      image: 'https://readdy.ai/api/search-image?query=empty%20commercial%20office%20space%20clean%20white%20walls&width=600&height=400&seq=service-2&orientation=landscape',
    },
    {
      title: 'Retirada de Muebles y Electrodomésticos',
      description: 'Recogida y transporte de muebles, electrodomésticos y enseres. Gestión responsable de residuos.',
      icon: 'ri-truck-line',
      image: 'https://readdy.ai/api/search-image?query=workers%20loading%20furniture%20into%20moving%20truck&width=600&height=400&seq=service-3&orientation=landscape',
    },
    {
      title: 'Limpieza por Síndrome de Diógenes',
      description: 'Servicio especializado y discreto para casos de acumulación compulsiva. Trato profesional y respetuoso.',
      icon: 'ri-shield-check-line',
      image: 'https://readdy.ai/api/search-image?query=professional%20cleaning%20team%20in%20protective%20equipment&width=600&height=400&seq=service-4&orientation=landscape',
    },
    {
      title: 'Pintura Final',
      description: 'Servicio de pintura para dejar el espacio listo para entregar. Acabados profesionales y limpios.',
      icon: 'ri-paint-brush-line',
      image: 'https://readdy.ai/api/search-image?query=painter%20working%20on%20white%20walls%20fresh%20paint%20finish&width=600&height=400&seq=service-5&orientation=landscape',
    },
    {
      title: 'Pequeñas Reparaciones',
      description: 'Reparaciones menores para dejar el inmueble en perfectas condiciones. Servicio completo y eficiente.',
      icon: 'ri-tools-line',
      image: 'https://readdy.ai/api/search-image?query=handyman%20doing%20repairs%20in%20apartment%20with%20tools&width=600&height=400&seq=service-6&orientation=landscape',
    },
  ];

  return (
    <section className="py-20 bg-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4">
            Nuestros servicios en El Prat de Llobregat
          </h2>
          <p className="text-lg text-secondary max-w-3xl mx-auto">
            Ofrecemos soluciones completas de <strong>vaciado de pisos</strong>, <strong>vaciado de locales</strong> y <strong>limpieza extrema</strong> en El Prat de Llobregat y toda la comarca del Baix Llobregat
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {services.map((service, index) => (
            <a
              key={index}
              href="/servicios"
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group cursor-pointer block"
            >
              {/* Image */}
              <div className="relative h-64 w-full overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-xl font-bold text-white">{service.title}</h3>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-2xl text-primary`}></i>
                </div>
                <p className="text-dark/80 mb-4 leading-relaxed">{service.description}</p>
                <span className="text-primary font-semibold flex items-center gap-2 group-hover:gap-3 transition-all">
                  Saber más
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-12">
          <a
            href="/servicios"
            className="inline-flex items-center gap-2 bg-primary text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-opacity-90 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            Ver Todos los Servicios
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
